import { formatSecondsToString } from '@/util/helpers'

export function getSVPColor (svp) {
  const threeMinutes = 180
  const fiveMinutes = 300

  if (svp < threeMinutes) {
    return '#6AAD00'
  }

  if (svp >= threeMinutes && svp <= fiveMinutes) {
    return '#FF9100'
  }

  if (svp > fiveMinutes) {
    return '#EA306B'
  }
}

export function createSVPBlock (avgConfirmTime) {
  const svpBlock = document.createElement('div')
  svpBlock.style.color = getSVPColor(avgConfirmTime)
  svpBlock.style.fontSize = '16px'
  // svpBlock.style.paddingLeft = '30px'

  svpBlock.appendChild(document.createTextNode(formatSecondsToString(avgConfirmTime)))

  return svpBlock
}
